import UploadCtaRow from './UploadCtaRow'

export default UploadCtaRow
